module.exports = __webpack_public_path__ + "static/media/kid-pouring-salt-in-cup.d7b5024d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-pouring-salt-in-cup.jpg
// module id = 808
// module chunks = 0